import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { storage, db } from '../../firebase-config';
import { ref, getDownloadURL } from 'firebase/storage';
import '../../assets/styles/AdminShared.css';

const AdminUploadedPictures = () => {
    const { projectId } = useParams(); // Get projectId from URL parameters
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUploadedFiles = async () => {
            if (!projectId) {
                console.error('Project ID is missing. Cannot fetch files.');
                setLoading(false);
                return;
            }

            try {
                const uploadsCollectionRef = collection(db, `projects/${projectId}/uploads`);
                const querySnapshot = await getDocs(uploadsCollectionRef);

                if (querySnapshot.empty) {
                    console.log('No uploaded files found.');
                    setUploadedFiles([]);
                    setLoading(false);
                    return;
                }

                const filesList = await Promise.all(
                    querySnapshot.docs.map(async (doc) => {
                        const data = doc.data();
                        const fileRef = ref(storage, data.url); // Use the storage URL to generate a preview
                        const downloadURL = await getDownloadURL(fileRef);

                        return {
                            id: doc.id,
                            ...data,
                            downloadURL,
                        };
                    })
                );

                setUploadedFiles(filesList);
            } catch (error) {
                console.error('Error fetching uploaded files:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchUploadedFiles();
    }, [projectId]);

    if (loading) {
        return <div className="ap-loading"><p>Loading uploaded files...</p></div>;
    }

    return (
        <div className="ap-page">
            <div className="ap-page-header">
                <a href="/admin" className="ap-back">← Back to dashboard</a>
                <p className="ap-eyebrow">Admin</p>
                <h1 className="ap-title">Uploaded Pictures</h1>
                <p className="ap-subtitle">Files uploaded by the client for this project.</p>
            </div>

            <div className="ap-section">
                <div className="ap-section-header">
                    <h2 className="ap-section-title">Uploaded Pictures for Project</h2>
                </div>
                <div className="ap-section-body">
                    {uploadedFiles.length === 0 ? (
                        <p className="ap-empty">No uploaded files found for this project.</p>
                    ) : (
                        <div className="ap-gallery">
                            {uploadedFiles.map((file) => (
                                <div key={file.id} className="ap-gallery-card">
                                    <img src={file.downloadURL} alt={file.name} className="ap-gallery-img" />
                                    <div className="ap-gallery-info">
                                        <p className="ap-gallery-cat">{file.category}</p>
                                        <p className="ap-gallery-name">{file.name}</p>
                                        <a
                                            href={file.downloadURL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="ap-gallery-dl"
                                            download={file.name}
                                        >
                                            Download
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminUploadedPictures;
